import { render } from "./CardPaymentHistoryList.vue?vue&type=template&id=6ecdc929&scoped=true"
import script from "./CardPaymentHistoryList.vue?vue&type=script&lang=js"
export * from "./CardPaymentHistoryList.vue?vue&type=script&lang=js"

import "./CardPaymentHistoryList.vue?vue&type=style&index=0&id=6ecdc929&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecdc929"]])

export default __exports__